/*=========================================================================================
  File Name: moduleReservedPackage.js
  Description: ReservedPackage Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleReservedPackageState.js'
import mutations from './moduleReservedPackageMutations.js'
import actions from './moduleReservedPackageActions.js'
import getters from './moduleReservedPackageGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
